import * as React from "react";
import type { SVGProps } from "react";

const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={16}
    viewBox="0 0 21 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.188 7.812a1.875 1.875 0 0 0-2.644 0 1.874 1.874 0 0 0 0 2.64l4.934 4.931c.021.022.027.053.051.078a1.86 1.86 0 0 0 1.334.54 1.86 1.86 0 0 0 1.334-.54c.022-.025.03-.056.053-.078L20.454 3.188a1.873 1.873 0 0 0 0-2.645 1.876 1.876 0 0 0-2.64 0l-10.95 10.94-3.675-3.671z"
    />
  </svg>
);
export default SvgCheckmark;
